import { RootState } from '../../model/model'

export const isSearchVisibleSelector = (state: RootState) => state.search.isSearchVisible

export const modelsFoundSelector = (state: RootState) => state.search.modelsFound
